if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.quantityInput = document.querySelector('.product-form__input.product-form__quantity input.quantity__input');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.productFormBtn = this.querySelector('.product-form__submit');

        this.handleProductFormBtnChanges();
        this.bindExtraFieldChange();
      }

      initQuantityHandlers() {
        this.quantityInput = document.querySelector('.product-form__input.product-form__quantity input.quantity__input');
        this.customifyQuantityInput = this.querySelector('[name="quantity"]');
        if(this.customifyQuantityInput){
          this.quantityInput.addEventListener('change', evt => {
            this.customifyQuantityInput.value = evt.target.value;
          });
          this.customifyQuantityInput.value = this.quantityInput.dataset.initValue;
        }
      }

      handleProductFormBtnChanges(){
        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' || mutation.type === 'childList') {
              if(this.productFormBtn.id == 'customify-addtocart'){
                observer.disconnect();
                this.initQuantityHandlers();
                this.saveExtraFieldsValue();
              }
            }
          }
        });

        observer.observe(this.productFormBtn, {
          attributes: true,
          childList: true,
          subtree: false,
        });
      }

      bindExtraFieldChange(){
        let allFields = document.querySelectorAll('.extra-field');
        this.submitButton = this.querySelector('[type="submit"]');
        if(allFields.length > 0){
          let requiredEmpty = false
          for (let i = 0; i < allFields.length; i++) {
            const field = allFields[i];
            if(field.hasAttribute('required') && !field.value){
              requiredEmpty = true;
            }

            if(!field.classList.contains('file')){
              field.addEventListener('change', evt => {
                this.saveExtraFieldsValue();
              })
            }else{
              field.addEventListener('click', evt => {
                evt.preventDefault();
                let currentField = this.form.querySelector(`input[name="${field.name}"]`);
                if(!currentField){
                  this.form.innerHTML += `<input type="file" name="${field.name}" accept="image/*" style="display: none;">`;
                  currentField = this.form.querySelector(`input[name="${field.name}"]`);
                  currentField.addEventListener('change', evt => {
                    field.value = currentField.value;
                    this.saveExtraFieldsValue();
                  });
                }
                
                currentField.click();
              });
            }
          }

          if(requiredEmpty){
              this.submitButton.disabled = true;
              this.submitButton.style.pointerEvents = 'none';
          }else{
            this.submitButton.disabled = false;
            this.submitButton.style.pointerEvents = 'auto';
          }
        }
      }
      
      saveExtraFieldsValue(){
        let allFields = document.querySelectorAll('.extra-field'), noteValue = '', requiredEmpty = false;
        this.submitButton = this.querySelector('[type="submit"]');
        for (let i = 0; i < allFields.length; i++) {
          const field = allFields[i];
          if(field.hasAttribute('required') && !field.value){
            requiredEmpty = true;
          }
          if(field.value){
            noteValue += `\n\n ${field.dataset.title}: ${field.value}`;
          }
        }

        if(requiredEmpty){
          this.submitButton.disabled = true;
          this.submitButton.style.pointerEvents = 'none';
        }else{
          this.submitButton.disabled = false;
          this.submitButton.style.pointerEvents = 'auto';
        }

        let changeEvent = new Event('input', { bubbles: true }), note =  this.querySelector('.customify-form-row #note');
        if(note){
          note.value = noteValue;
          note.dispatchEvent(changeEvent);
        }else{
          let customifyNote = this.form.querySelector('input[name="properties[customify_note]"]');

          if(customifyNote){
            customifyNote.value = noteValue;
          }else{
            for (let i = 0; i < allFields.length; i++) {
              const field = allFields[i];
              let currentField = this.form.querySelector(`input[name="${field.name}"]`);
              if(!field.classList.contains('file')){
                if(currentField){
                  currentField.value = field.value;
                }else{
                  this.form.innerHTML += `<input type="hidden" name="${field.name}" value="${field.value}">`;
                }
              }
              
            }
          }
        } 
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        if(this.quantityInput != null){
          if(this.quantityInput.dataset.cartQuantity >= this.quantityInput.dataset.max || this.quantityInput.value > this.quantityInput.dataset.max){
            this.handleErrorMessage(`The maximum you may purchase is ${this.quantityInput.dataset.max}.`);
            return;
          }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
